import { DataGrid } from '@mui/x-data-grid';

const DataTable = ({ columns, data }: {columns: any[], data: any[]}) => {
	return (
		<div style={{ height: 550, width: '100%' }}>
			<DataGrid
				disableSelectionOnClick
				rows={data}
				columns={columns}
				pageSize={8}
				rowsPerPageOptions={[5]}
				checkboxSelection
				headerHeight={42}
			/>
		</div>
	);
};

export default DataTable;
